var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2851 9H17.7301C12.2701 9 9.01514 12.255 9.01514 17.715V30.27C9.01514 35.73 12.2701 38.985 17.7301 38.985H30.2851C35.7451 38.985 39.0001 35.73 39.0001 30.27V17.715C39.0001 12.255 35.7451 9 30.2851 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7148 16.8301H27.4798C25.8448 16.8301 24.5698 18.1051 24.5698 19.7401V21.9752C24.5698 23.6102 25.8448 24.8852 27.4798 24.8852H30.3448C30.2248 27.6002 29.5948 28.0051 27.7798 29.0701C27.2398 29.3851 27.0748 30.0751 27.3898 30.6151C27.5998 30.9751 27.9748 31.1702 28.3648 31.1702C28.5598 31.1702 28.7548 31.1251 28.9348 31.0201C31.6198 29.4301 32.6248 28.3951 32.6248 23.7751V19.7701C32.6248 18.1351 31.3198 16.8301 29.7148 16.8301Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 16.8301H18.285C16.65 16.8301 15.375 18.1051 15.375 19.7401V21.9752C15.375 23.6102 16.65 24.8852 18.285 24.8852H21.15C21.03 27.6002 20.4 28.0051 18.585 29.0701C18.045 29.3851 17.88 30.0751 18.195 30.6151C18.405 30.9751 18.78 31.1702 19.17 31.1702C19.365 31.1702 19.56 31.1251 19.74 31.0201C22.425 29.4301 23.43 28.3951 23.43 23.7751V19.7701C23.415 18.1351 22.11 16.8301 20.52 16.8301Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteUp);
export default __webpack_public_path__ + "static/media/quoteUp.9a9756c7cfe8450550e7e33bda304a4e.svg";
export { ForwardRef as ReactComponent };